import React from "react";
import { render } from "react-dom";
import { Button, List, ListItem, SearchInput, Icon } from "react-onsenui";
import Substance from "./Substance";
import { getSubstances } from "../../services/megamix";
import ShareUrlButton from "../ShareUrlButton";
import Wizard from './Wizard'; // Import the new Wizard component

const style = {
  pageContainer: {},
  searchContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  searchInput: {
    margin: "5px"
  },
  filterButton: {
    margin: "10px 5px 0px 5px",
    padding: "5px 5px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    cursor: "pointer",
    backgroundColor: "#f9f9f9",
    transition: "background-color 0.3s",
    whiteSpace: "nowrap" // Zabezpieczenie przed łamaniem tekstu
  },

  filterButtonActive: {
    backgroundColor: "#e0e0e0",
    color: "#000",
    border: "1px solid #ccc",
  },
};


// Mapowanie filtrów
const filterCombinations = {
  "Psychedelic,Stimulants": ["MDxx", "Substituted phenethylamines + Psychedelic"],
  // "Amphetamines": ["Amphetamine", "Substituted amphetamines"],
  // "Phenethylamines": ["Substituted phenethylamines"],
  // "Tryptamines": ["Substituted tryptamines"],
};

class SubstancesIndex extends React.Component {
  state = {
    searchInput: '',
    vialClicked: false,
    selectedClassFilters: [], // Tablica przechowująca wybrane filtry
    letterHistory: {}, // Przechowuje litery, które już zostały wyświetlone
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    
    // Nasłuchuj na zdarzenie "popstate" - przycisk cofnij/dalej
    window.addEventListener('popstate', this.handlePopState);

    // Handle analyze param
    if (params.has('analyze')) {
      this.setState({
        vialClicked: true,
        selectedClassFilters: []
      });
    }
    
    // Handle substance param
    if (params.has('substance')) {
      const substanceToken = params.get('substance');
      const formattedSubstanceToken = substanceToken.replace(/-/g, ' '); 
      this.setState({ 
        selectedClassFilters: ['Show all'],
        searchInput: formattedSubstanceToken
      }, () => {
        const substance = getSubstances().find(s => s.token === substanceToken);      
        if (substance) {
          const contentEl = document.getElementById("substance-index-content-" + substance.id);
          const listitemEl = document.getElementById("substance-index-listitem-" + substance.id);
          if (contentEl && listitemEl) {
            render(<Substance substance={substance}></Substance>, contentEl);
            listitemEl.classList.add("open");
          }
        }
        
        // Force re-render after state update
        setTimeout(() => {
          this.forceUpdate();
        }, 100); // This ensures the search input displays correctly
      });
    }

    // Handle initialSearchTerm if it's provided as a prop
    if (this.props.initialSearchTerm != null) {
      this.setState({
        searchInput: this.props.initialSearchTerm,
        selectedClassFilters: ['Show all'], // Automatically activate "Show all"
      });
  
      // Automatically trigger the search logic with "Show all" filter
      this.props.onSearchTermChange(
        this.props.initialSearchTerm.length > 1,
        this.props.initialSearchTerm,
        false
      );
  
      // Force re-render after state update
      setTimeout(() => {
        this.forceUpdate();
      }, 100);
    }
  }

  componentWillUnmount() {
    // Usuń nasłuchiwacz popstate przy odmontowywaniu komponentu
    window.removeEventListener('popstate', this.handlePopState);
  }

  handlePopState = (event) => {
    const params = new URLSearchParams(window.location.search);
    // Obsługuje URL po zmianie stanu historii
    if (params.has('substance')) {
      const formattedSubstanceToken = substanceToken.replace(/-/g, ' ');
      this.setState({ 
        selectedClassFilters: ['Show all'],
        searchInput: formattedSubstanceToken
      }, () => {
        const substance = getSubstances().find(s => s.token === substanceToken);
      
        if (substance) {
          const contentEl = document.getElementById("substance-index-content-" + substance.id);
          const listitemEl = document.getElementById("substance-index-listitem-" + substance.id);
          if (contentEl && listitemEl) {
            render(<Substance substance={substance}></Substance>, contentEl);
            listitemEl.classList.add("open");
          }
        }
        setTimeout(() => {
          this.forceUpdate();
        }, 100);
      });
    } else {
      // Jeśli nie ma parametru substance, możesz np. wyczyścić wyszukiwanie
      this.setState({
        searchInput: '',
        selectedClassFilters: []
      });
    }
  }
  

  setSearchInput(input) {
    this.setState({ searchInput: input });
    this.props.onSearchTermChange(input.length > 1, input);
  }

  unsetSearchInput() {
    this.setState({ searchInput: '' });
    this.props.onSearchTermChange(false, '');
  }

  isSearchActive() {
    return this.state.searchInput.length > 1;
  }

  onClearSearchInputClick() {
    const { vialClicked, searchInput } = this.state;
  
    if (searchInput) {
      this.unsetSearchInput();  // Clear the search input field only when there's an active input
    }
  
    if (!vialClicked) {
      // Switch directly to getReactions, regardless of other active filters
      this.setState({
        vialClicked: true,
        selectedClassFilters: [],  // Clear all filters
      });
      this.props.onSearchTermChange(false, '', true); // Activate getReactions
    } else {
      // Revert back to "Show all" when getReactions is active
      this.setState({
        vialClicked: false,
        selectedClassFilters: ['Show all'],  // Activate "Show all"
      });
      this.props.onSearchTermChange(false, '', false); // Deactivate getReactions
    }
  }
  
  

  onSearchInputChange(event) {
    const input = event.target.value;
  
    // Set the search input
    this.setSearchInput(input);
  
    // If there are no filters selected, activate "Show all"
    if (this.state.selectedClassFilters.length === 0) {
      this.setState({
        selectedClassFilters: ['Show all'], // Automatically activate "Show all"
      });
    }
  
    // Ensure the parent is informed about the search term change
    this.props.onSearchTermChange(input.length > 1, input, false);
  }
  

  handleFilterClick(filter) {
    this.setState((prevState) => {
      const { vialClicked } = prevState;
  
      if (filter === 'Reset') {
        this.setState({
          selectedClassFilters: [], // Wyczyszczenie wszystkich filtrów
          vialClicked: false, // Deaktywacja vialClicked po naciśnięciu Reset
          searchInput: '' // Wyczyszczenie pola wyszukiwania
        });
        this.props.onSearchTermChange(false, '', false); // Resetowanie stanu nadrzędnego
  
        if (this.resetWizard) {
          this.resetWizard(); // Resetowanie Wizard, jeśli dotyczy
        }
  
        return; // Zakończ funkcję po zresetowaniu
      }
  
      // Jeśli aktywne są reakcje i kliknięto filtr, dezaktywuj reakcje
      if (vialClicked && filter !== 'Show all') {
        this.setState({ vialClicked: false }); // Deaktywacja reakcji
        this.props.onSearchTermChange(false, '', false); // Wyłącz reakcje
      }
  
      if (filter === 'Show all') {
        if (prevState.selectedClassFilters.includes('Show all')) {
          return {
            selectedClassFilters: [] // Wyczyszczenie wszystkich filtrów, pokaż Wizard
          };
        } else {
          return {
            selectedClassFilters: ['Show all'], // Aktywacja filtra "Show all"
          };
        }
      } else {
        // Tylko jeden aktywny filtr na raz
        return {
          selectedClassFilters: [filter] // Zastąp wszystkie inne filtry nowym filtrem
        };
      }
    });
}
  
  getFilteredSubstances() {
    let substances = getSubstances();
    const { selectedClassFilters, searchInput } = this.state;
  
    // Handle filtering when "Show all" is selected
    if (selectedClassFilters.includes('Show all')) {
      // Apply search filter if search input is active
      if (this.isSearchActive()) {
        const input = searchInput.trim().replace(/[^a-zA-Z0-9, \-]/gm, '');
        const regexPattern = input
          .split(/\s+/)
          .map(word => word.split('').map(char => `[\\s,-]*${char}[\\s,-]*`).join(''))
          .join('[\\s,-]+');
        
        const regexp = new RegExp(regexPattern, 'i');
  
        // Separate into popular and non-popular substances
        const popularSubstances = substances.filter(substance =>
          substance.isPopular && (regexp.test(substance.commonName) || regexp.test(substance.name))
        );
  
        const uncommonSubstances = substances.filter(substance =>
          !substance.isPopular && (regexp.test(substance.commonName) || regexp.test(substance.name))
        );
  
        return { popularSubstances, uncommonSubstances };
      }
  
      // If no search input is active, return all substances split by popularity
      const popularSubstances = substances.filter(substance => substance.isPopular);
      const uncommonSubstances = substances.filter(substance => !substance.isPopular);
  
      return { popularSubstances, uncommonSubstances };
    }
  
  // Handle other filters if "Show all" is not selected
  if (selectedClassFilters.length > 0) {
    const additionalClasses = this.getAdditionalClasses(selectedClassFilters);
    
    substances = substances.filter(substance => {
      return selectedClassFilters.every(filter => {
        // Map classes
        const effectiveFilter = filter === 'Amphetamines' ? ['Amphetamine', 'Substituted amphetamines'] :
                                filter === 'Cathinones' ? ['Cathinone', 'Substituted cathinones'] :
                                filter === 'Phenethylamines' ? 'Substituted phenethylamines' :
                                filter === 'Tryptamines' ? 'Substituted tryptamines' : filter;

        // If the filter is mapped to multiple classes, check if the substance belongs to any of them
        if (Array.isArray(effectiveFilter)) {
          return effectiveFilter.some(classFilter => 
            substance.classes && substance.classes.includes(classFilter)
          );
        }

        // Otherwise, handle normal filtering
        return (substance.classes && substance.classes.includes(effectiveFilter)) ||
               (filter === 'Common' && substance.isPopular) ||
               additionalClasses.some(extraClass => substance.classes && substance.classes.includes(extraClass));
      });
    });
  }
    
  
    // Apply search filter when other filters are active
    if (this.isSearchActive()) {
      const input = searchInput.trim().replace(/[^a-zA-Z0-9, \-]/gm, '');
      const regexPattern = input
        .split('')
        .map(char => `[\\s,-]*${char}[\\s,-]*`)
        .join('');
      const regexp = new RegExp(regexPattern, 'i');
  
      // Filter substances based on search input
      return substances.filter(substance =>
        regexp.test(substance.commonName) || regexp.test(substance.name)
      );
    }
  
    return substances;
  }
  
  
  getAdditionalClasses(selectedFilters) {
    // Sortujemy filtry, aby dopasować do zdefiniowanych kombinacji w mapowaniu
    const sortedFilters = [...selectedFilters].sort().join(',');

    // Sprawdzamy, czy dla wybranych filtrów istnieje dodatkowe mapowanie
    return filterCombinations[sortedFilters] || [];
  }

  onSubstanceClicked(event, substance) {
    let clickEl = event.target;
    let i = 0;
    while (clickEl != null) {
      i++;
      if (clickEl.tagName === "ONS-CARD") {
        return;
      }
      if (i > 100) {
        console.log("ERR");
        return;
      }
      clickEl = clickEl.parentElement;
    }

    const contentEl = document.getElementById("substance-index-content-" + substance.id);
    const listitemEl = document.getElementById("substance-index-listitem-" + substance.id);

    if (contentEl.innerHTML.length > 1) {
      render(<></>, contentEl);
      listitemEl.classList.remove("open");
    } else {
      render(<Substance substance={substance}></Substance>, contentEl);
      listitemEl.classList.add("open");

      // Check if commonName contains special characters, and use name instead if so
      const isDuplicateCommonName = getSubstances().filter(s => s.commonName === substance.commonName).length > 1;
      const containsSpecialChars = /[()[\],]/.test(substance.commonName);
      
      // Jeśli jest duplikat, weź tylko część `name` przed pierwszym nawiasem
      let urlToken = containsSpecialChars || isDuplicateCommonName
        ? substance.name.split('(')[0].trim() // Obcięcie od pierwszego nawiasu
        : substance.token;
      
      // Jeśli jest potrzeba, możesz również zamienić spacje na myślniki, aby URL wyglądał lepiej
      urlToken = urlToken.replace(/\s+/g, '-');
      // Aktualizujemy URL bez przeładowania strony
      const newPathname = `${window.location.pathname}?substance=${urlToken}`;
      window.history.pushState({ substance: substance.id }, '', newPathname);
        }
}


  renderFilterButtons() {
    const filters = ['Reset', 'Show all', 'Common', 'Stimulants', 'Depressant', 'Psychedelic', 'Cannabinoid', 'Dissociatives', 'Amphetamines', 'Benzodiazepines', 'Cathinones', 'Lysergamides', 'Opioids', 'Phenethylamines', 'Tryptamines'];
    const { selectedClassFilters } = this.state;
  
    return (
      <div className="filters-container">
        {filters.map(filter => {
          const isActive = selectedClassFilters.includes(filter);
          return (
            <div
              key={filter}
              style={{
                ...style.filterButton,
                ...(isActive ? style.filterButtonActive : {})
              }}
              onClick={() => this.handleFilterClick(filter)}
            >
              {filter}
            </div>
          );
        })}
      </div>
    );
  }

  renderSubstanceRow(substance, index) {
    const letter = substance.name.substring(0, 1).toUpperCase();
    const showLetter = !this.state.letterHistory[letter];

    // Aktualizujemy historię liter, aby wiedzieć, które już wyświetliliśmy
    if (showLetter) {
      this.state.letterHistory[letter] = true;
    }

    return (
      <ListItem
        key={substance.id}
        onClick={(e) => this.onSubstanceClicked(e, substance)} // Kliknięcie w substancję
        tappable
        id={"substance-index-listitem-" + substance.id}
        class="substance-index-listitem"
      >
        <div className="substance-index-listitem-header clickable">
          <div className="substance-index-letter" style={showLetter ? {} : {opacity: 0}}>{letter}</div>
          <div className="testdrugs-header">{substance.name}</div>
        </div>
        <div className="substance-index-listitem-content">
          <div id={"substance-index-content-" + substance.id}></div>
        </div>
      </ListItem>
    );
  }

  renderSubstancesList() {
    const { selectedClassFilters } = this.state;
    
    // Reset letter history before rendering the list
    this.state.letterHistory = {};  // Always reset letter history before rendering
    
    // If reactions are being shown, hide the substance list
    if (this.props.showReactions) {
      return null;  // Do not render the substance list if reactions are active
    }
    
    // Show Wizard when no filters are selected
    if (selectedClassFilters.length === 0) {
      return <Wizard onReset={(resetWizard) => this.resetWizard = resetWizard} />;
    }
    
    // Show substances when "Show all" filter is active
    if (selectedClassFilters.includes('Show all')) {
      const { popularSubstances, uncommonSubstances } = this.getFilteredSubstances();
      const totalSubstancesCount = popularSubstances.length + uncommonSubstances.length;
  
      return (
        <div>
          <h3  style={{margin: "20px 0px 10px 10px"}}>Common substances ({popularSubstances.length}/{totalSubstancesCount})</h3>
          <List
            dataSource={popularSubstances}
            renderRow={this.renderSubstanceRow.bind(this)}
          />
          <h3 style={{margin: "20px 0px 10px 10px"}}>Uncommon substances ({uncommonSubstances.length}/{totalSubstancesCount})</h3>
          <List
            dataSource={uncommonSubstances}
            renderRow={this.renderSubstanceRow.bind(this)}
          />
        </div>
      );
    }
  
    // Apply filters if other filters are selected
    const filteredSubstances = this.getFilteredSubstances();
    const totalSubstancesCount = filteredSubstances.length;
  
    return (
      <div>
        <h3 style={{ margin: "20px 10px" }}>Substances ({totalSubstancesCount})</h3>
        <List
          dataSource={filteredSubstances}
          renderRow={this.renderSubstanceRow.bind(this)}
        />
      </div>
    );
  }
  
  
  render() {
    console.log('Search Input State:', this.state.searchInput);

    return (
      <div style={style.pageContainer}>
        <div style={style.searchContainer}>
          <div style={{ display: "flex", alignItems: "center" }}>
            {this.props.NoOnsen === true && (
              <ShareUrlButton size={22} withButtonText={true} />
            )}
<SearchInput
  value={this.state.searchInput || ""}
  float
  onChange={this.onSearchInputChange.bind(this)}
  placeholder="Search substances…"
  style={style.searchInput}
/>

            <Icon icon="fa-vial" size={22} marginLeft={"f10px"} color={"grey"} onClick={() => this.onClearSearchInputClick()} />
          </div>
          {this.renderFilterButtons()}
        </div>
        {this.renderSubstancesList()}
      </div>
    );
  }
}

export default SubstancesIndex;
